export default {
  all: null,
  quickCatchment: false,
  layers: [],
  activeLayer: null,
  ageMicroraster: null,
  buyingPowerMicroraster: null,
  competitors: null,
  microraster: null,
  addresses: null,
  infoDialog: false,
  welcomeDialog: true,
};
